export interface ApiResp {
	status: number,
	message?: string,
	data?: any
}
export interface LoginForm {
	loginId: string,
	password: string
}

export interface CreditForm {
	cardName: string,
	cardNo: string,
	secure: string,
	month: string,
	year: string,
	tel: string,
	email: string,
	email2: string
}
export interface InputCheck {
	varName: string,
	message: string,
	re: RegExp | Function,
	require?: boolean,
  delegate?: Function,
}
export interface CheckResult {
	varName: string,
	message?: string,
	check: boolean
  require?: boolean
}

export enum MessageType {
    Info, Caution, Warning
}
export enum MessageStatus {
    Show, Hide 
}
export interface MessageInfo {
    id: number,
    type: MessageType,
    target: number,
    startDate: number,
    endDate: number,
    viewWeight: number,
    status: MessageStatus,
    message: string,
    memberIds?: string,
}

export enum MessageTarget {
    Normal = 1,
    Senmon = 2,
    Senkou = 4,
    Coordinator = 8,

    All = 15,

    MemberIds = 16,
}

export enum MemberType {
	Normal = 10,
	Senmon = 20,
	Senkou = 30,
	Coordinator = 40,
}

export const TARGET_FLAG_MAP = {
	[MemberType.Normal]: MessageTarget.Normal,
	[MemberType.Senkou]: MessageTarget.Senkou,
	[MemberType.Senmon]: MessageTarget.Senmon,
	[MemberType.Coordinator]: MessageTarget.Coordinator,
}

export const IDOU_KUBUNS = {
	"入会中": 0,
	"退会予定": 1,
	"休会": 2,
	"退会": 3,
	"物故": 4,
	"資格喪失": 5,
}

export enum IdouKubun {
  Member,
  Leaving,
  Recess,
  Withdrawn,
  Deceased,
  Disqualified,
}

export enum ModificationType {
  Basic,
  Work,
  Home,
  Recess,
  Recess2,
  Withdrawal,
}
export interface ModifyForm {
  memberId: string
  type: ModificationType
  body: string
}

export interface BaseForm {
  lastName: string
  firstName: string
  lastNameYomi: string
  firstNameYomi: string
  lastNameEng: string
  firstNameEng: string
  middleNameEng: string
  jsog: string
  jua: string
  bikou: string
}
export interface WorkForm {
  addrSelect: boolean
  workPlace: string
  workSection: string
  occupation: string
  addrType: string
  wZip1: string
  wZip2: string
  wPref: string
  wAddr: string
  wTel: string
  wFax: string
  zip1: string
  zip2: string
  pref: string
  addr1: string
  addr2: string
  tel: string
  fax: string
  mobile: string
  bikou: string
}
export interface RecessForm {
  fromYear: string
  fromMonth: string
  toYear: string
  toMonth: string
  rfReason: string
  contactInfo: string
  recess: string
  rfCountry: string
  rfZip: string
  rfAddr1: string
  rfAddr2: string
  rfSection: string
  bikou: string
}

export interface AddressForm {
  addrSelect: boolean
  zip1: string
  zip2: string
  pref: string
  addr1: string
  addr2: string
  tel: string
  fax: string
  mobile: string
  bikou: string
}
export interface WithdrawalForm {
  telWithdrawal: string
  when: string
  reason: string
  bikou: string
}
